import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import Component from "./components/component";
// import MyButton from "./components/mybutton";
// import UserExample from "./components/UserExample";
// import UserImg from "./images/user.png";
// import MyProps from "./components/MyProps";
// import { Container } from 'react-bootstrap';
import Home from "./components/router/home";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import "./App.css";


function App() {  

  // const bodystyles = {
  //   margin: "10px"
  // };

  // const user = {
  //   name: "john",
  //   image: UserImg,
  //   imagesize: 90,
  //   information: "Front End Developer"
  // };

  return (
    // <div style={bodystyles}>
    //   <Component message="Welcome to My React Page" />
    //   <h1>Welcome</h1>
    //   <MyButton />
    //   <UserExample {...user} />
    //   <MyProps message="My React App" />
    <Router>
      <Routes>
        <Route>
          <Route exact path='/' element={<Home />} />
        </Route>
      </Routes>
    </Router>

    // </div>
  );
}

export default App;
